const en = [
  {
    id: 'faq1',
    question: 'What type of file should I upload?',
    answer: 'You can upload a JPG, a PNG, a DWG or PDF-files. It should contain 1 apartment or 1 house floor so AI could understand what it should visualize.',
    isDefaultOpened: true,
  },
  {
    id: 'faq2',
    question: 'Can I change the interior design, furniture, wall color, etc.?',
    answer: 'Our Quality Assurance team can customize your floor plan after rendering. Contact <a href="mailto:customerservice@getfloorplan.com">customerservice@getfloorplan.com</a> for editing.',
  },
  {
    id: 'faq3',
    question: 'Why will I get visuals in 24 hours?',
    answer: 'Our Quality Assurance team checks every floor plan to make sure there are no mistakes after AI rendering. That is why a guaranteed result matching the original plan you receive in 24 hours.',
  },
  {
    id: 'faq4',
    question: 'Can I get a refund?',
    answer: 'You can send us an email to request a refund. Depending on the mean of payment you’ll receive your money back from 3 to 7 business days.',
  },
  {
    id: 'faq5',
    question: 'Can I choose 2 interior designs at once for 1 floor plan?',
    answer: 'One chosen style is applied to all uploaded files. You should upload your floor plan for the second time to have it with another design.',
  },
];

export const faq = { en, ru: en };
